document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.btn');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            const footerContent = this.closest('.footer-block').querySelector('.footer-content');

            if (footerContent.style.maxHeight) {
                footerContent.style.maxHeight = null;
                this.classList.remove('active');
            } else {
                footerContent.style.maxHeight = footerContent.scrollHeight + "px";
                this.classList.add('active');
            }
        });
    });
});
